export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8446.61432a42.jpg";